/**
 * RİKİ DEĞİŞİKLİĞİ — Selleasy sepet içi widget'ı ↔ Horizon sepet çekmecesi / sepet sayfası.
 * Brief: docs/claude-code-selleasy-cekmece-brief.md (v20). Selleasy'nin kodu ve CSS'i ezilmez;
 * yalnız Selleasy'nin kendi olayları dinlenir ve temanın kendi yolları çağrılır.
 *
 * 1) Yenileme: Selleasy kendi isteğiyle sepete ekleyince window'a `lbSECartUpdated`
 *    (detail.isSelleasy: true) gönderir; kendi drawerRefresh'i Horizon'u tanımadığı için
 *    çekmece bayat kalırdı. Burada sepet bölümleri `sections=` ile çekilir ve temanın
 *    standart CartLinesUpdateEvent'i gönderilir — ürün formunun "sepete ekle" yolunun aynısı:
 *    çekmece ve sepet sayfası morph olur; rozet, kargo baremi ve satırlar güncellenir.
 *    Yeni satır listenin başına geldiği için çekmece başa kaydırılır.
 *    Temanın kendi sepet değişiklikleri (isSelleasy: false) zaten kendi yolunda; dokunulmaz.
 * 2) Widget'ın geri gelmesi: morph, sunucu HTML'inde olmayan Selleasy widget'ını siler.
 *    Yer tutucu (.riki-selleasy-yeri) taze kopyasıyla değiştirilir; Selleasy'nin kendi
 *    MutationObserver'ı seçiciyi yeniden görür ve eksik widget varsa kendisi basar.
 *    (lbSelleasyUtils.init widget çizmez, entegrasyon dinleyicisi kurar — çağrılmaz.)
 * 3) Beden ön-seçimi: sepet içi widget çizilince (lbWidgetRendered) tetikleyici satırın
 *    seçenekleri (Selleasy'nin widget'a koyduğu triggers[0].variant_options, ör. ["3 Yaş"])
 *    widget'taki varyantlarda BİREBİR varsa o varyant seçilir ve `change` gönderilir —
 *    Selleasy'nin kendi matchVariant'ının yaptığının aynısı; sepet içi widget'ta o ayar yok.
 *    Eşleşme yoksa ya da seçenek kapalıysa dokunulmaz.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

const YER_TUTUCU = '.riki-selleasy-yeri';
const SEPET_ICI_WIDGET = 'lb-upsell-widget[widget^="widget#icu"]';

/** Selleasy her sepet değişiminde taze sepeti gönderir; eklenen satırı bulmak için saklanır. */
let sonSepet = null;
let yenileniyor = false;
let bekleyen = null;

window.addEventListener('lbSECartUpdated', (event) => {
  const detail = /** @type {CustomEvent} */ (event).detail || {};
  const oncekiSepet = sonSepet;
  if (gecerliSepet(detail.cart)) sonSepet = detail.cart;

  if (!detail.isSelleasy) return;
  // Kapsam: sepet içi widget — açık çekmece ya da sepet sayfası. Kapalı çekmeceli bir sayfada
  // Selleasy eklemesini temanın kendi ürün formu karşılar (PDP akışı bu turun dışında).
  const cekmeceAcik = document.querySelector('#cart-drawer')?.hasAttribute('open');
  const sepetSayfasi = document.querySelector('cart-items-component:not([data-section-id="cart-drawer-section"])');
  if (!cekmeceAcik && !sepetSayfasi) return;

  istekle({ detail, oncekiSepet });
});

window.addEventListener('lbWidgetRendered', (event) => {
  const widget = /** @type {CustomEvent} */ (event).detail?.widgetSrcElement;
  if (widget instanceof HTMLElement && widget.matches(SEPET_ICI_WIDGET)) bedeniEslestir(widget);
});

/** Art arda gelen Selleasy olaylarında tek yenileme koşar; sonuncusu sıraya alınır. */
function istekle(is) {
  if (yenileniyor) {
    bekleyen = is;
    return;
  }
  yenileniyor = true;
  yenile(is)
    .catch((hata) => console.warn('[riki-selleasy] sepet yenilenemedi:', hata))
    .finally(() => {
      yenileniyor = false;
      if (bekleyen) {
        const siradaki = bekleyen;
        bekleyen = null;
        istekle(siradaki);
      }
    });
}

async function yenile({ detail, oncekiSepet }) {
  const bolumler = [...document.querySelectorAll('cart-items-component[data-section-id]')]
    .map((el) => /** @type {HTMLElement} */ (el).dataset.sectionId)
    .filter(Boolean);
  if (!bolumler.length) return;

  const [sepet, sections] = await Promise.all([
    gecerliSepet(detail.cart) ? detail.cart : fetch(`${rota()}cart.js`).then((r) => r.json()),
    fetch(`${window.location.pathname}?sections=${encodeURIComponent(bolumler.join(','))}`).then((r) => r.json()),
  ]);

  const lines = eklenenSatirlar(detail.response, oncekiSepet, sepet);
  const ertelenen = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines, promise: ertelenen.promise })
  );
  ertelenen.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(sepet),
    detail: {
      items: sepet.items,
      itemCount: lines.reduce((toplam, satir) => toplam + satir.quantity, 0),
      sections,
      source: 'riki-selleasy',
      didError: false,
    },
  });

  // Bileşenlerin then'leri bu await'ten önce koşar ve morph eşzamanlıdır: buradan sonra DOM yeni.
  await ertelenen.promise;
  await new Promise((tamam) => requestAnimationFrame(tamam));

  document
    .querySelectorAll('#cart-drawer .cart-drawer__items, #cart-drawer .cart-drawer__content')
    .forEach((el) => {
      el.scrollTop = 0;
    });
  yerTutucuyuTazele();
}

/** Morph silmişse Selleasy'nin gözlemcisine seçiciyi yeniden göster; widget yerindeyse dokunma. */
function yerTutucuyuTazele() {
  document.querySelectorAll(YER_TUTUCU).forEach((yer) => {
    if (yer.previousElementSibling?.matches('lb-upsell-widget')) return;
    yer.replaceWith(yer.cloneNode(false));
  });
}

/** Standart olay en az bir satır ister: Selleasy yanıtı → sepet farkı → ilk satır sırasıyla. */
function eklenenSatirlar(yanit, onceki, sonraki) {
  const yanitSatirlari = Array.isArray(yanit?.items) && !gecerliSepet(yanit) ? yanit.items : [];
  let satirlar = yanitSatirlari.map((s) => ({ merchandiseId: String(s.variant_id ?? s.id), quantity: s.quantity || 1 }));

  if (!satirlar.length && gecerliSepet(onceki)) {
    const eskiAdet = new Map(onceki.items.map((s) => [s.key, s.quantity]));
    satirlar = sonraki.items
      .filter((s) => s.quantity > (eskiAdet.get(s.key) || 0))
      .map((s) => ({ merchandiseId: String(s.variant_id), quantity: s.quantity - (eskiAdet.get(s.key) || 0) }));
  }
  if (!satirlar.length && sonraki.items?.[0]) {
    satirlar = [{ merchandiseId: String(sonraki.items[0].variant_id), quantity: 1 }];
  }
  return satirlar;
}

function bedeniEslestir(widget) {
  const tetik = /** @type {any} */ (widget).lbPayload?.widget?.triggers?.[0];
  const hedef = (tetik?.variant_options || []).map(normal);
  if (!hedef.length || tetik.variant_title === 'Default Title') return;

  widget.querySelectorAll('lb-variant-picker').forEach((secici) => {
    const select = secici.querySelector('select.lb-variant-picker');
    const varyantlar = /** @type {any} */ (secici).lbPayload?.product?.variants || [];
    if (!(select instanceof HTMLSelectElement)) return;

    const eslesen = varyantlar.find((v) => {
      const secenekler = (v.options || []).map(normal);
      return secenekler.length === hedef.length && secenekler.every((s, i) => s === hedef[i]);
    });
    const secenek = eslesen && [...select.options].find((o) => o.value === String(eslesen.id) && !o.disabled);
    if (!secenek || select.value === secenek.value) return;

    select.value = secenek.value;
    select.dispatchEvent(new Event('change'));
  });
}

function normal(deger) {
  return String(deger).trim().toLocaleLowerCase('tr');
}

function gecerliSepet(sepet) {
  return Boolean(sepet) && Array.isArray(sepet.items) && typeof sepet.item_count === 'number' && 'token' in sepet;
}

function rota() {
  return window.Shopify?.routes?.root || '/';
}
